import * as React from 'react'
import classNames from 'classnames'

import { Text, TextName } from 'sdk'
import { Button } from 'sdk/button/Button'
import { NewsfeedCard } from 'pages/newsfeed/components/newsfeed-card/NewsfeedCard'

import { DEVELOPER_ARTICLE_CATEGORIES } from 'core/constants'
import { NewsfeedEntry, NewsfeedRecordType } from 'core/interfaces'

import classes from './style.module.scss'

interface ComponentProps {
  newsfeed: NewsfeedEntry[]
}

export const DeveloperNewsSection: React.FC<ComponentProps> = ({ newsfeed }) => {
  const itemsPerPage = 3
  const [visibleCount, setVisibleCount] = React.useState(itemsPerPage)
  const [lastRevealStart, setLastRevealStart] = React.useState<number | null>(null)

  const articles = React.useMemo(() => (
    newsfeed.filter((entry) => {
      if (entry.type !== NewsfeedRecordType.Article) {
        return false
      }

      return DEVELOPER_ARTICLE_CATEGORIES.includes(entry.category)
    })
  ), [newsfeed])

  const visibleArticles = articles.slice(0, visibleCount)
  const hasMore = visibleCount < articles.length

  if (articles.length === 0) {
    return null
  }

  const handleLoadMore = (): void => {
    setLastRevealStart(visibleCount)
    setVisibleCount((previousCount) => Math.min(previousCount + itemsPerPage, articles.length))
  }

  return (
    <section className={classes.wrapper}>
      <Text type={TextName.H2}>Developer News</Text>
      <div className={classes.cardsGrid}>
        {visibleArticles.map((entry, index) => (
          <div
            key={entry.id}
            className={classNames(
              classes.cardItem,
              {
                [classes.cardItemAnimated]: lastRevealStart !== null && index >= lastRevealStart,
              },
            )}
          >
            <NewsfeedCard entry={entry} />
          </div>
        ))}
      </div>
      {hasMore ? (
        <div className={classes.loadMoreContainer}>
          <Button as="button" onClick={handleLoadMore} className={classes.loadMoreButton}>
            Load more
          </Button>
        </div>
      ) : null}
    </section>
  )
}
